export const LOCALES = {
  "en": {
    flag: "🇺🇸"
  },
  "pt-BR": {
    flag: "🇧🇷"
  }
};